import axios from 'axios'
import Vue from 'vue'
export default {
    install: (Vue, options) => {
        const image = {
            //check whether if the file upload is images
            isFileImage(file) {
                return file && file['type'].split('/')[0] === 'image';
            },

            //validate size in mb
            validSizeInMb(size, max){
                const fileSizeKb = parseFloat((size / 1024)).toFixed(2);
                const fileSizeMb = parseFloat(fileSizeKb / 1000);
                return fileSizeMb <= max;
            },

            //return image in compress size
            //file parameter
            async onCompressImage (file, max_size = 5) {
                //let file = ev.target.files[0]; // get the file
                let self = this;
                const MIME_TYPE_JPG = 'image/jpeg'; // Add the JPG MIME type
                //check if the file is image if not an image return original file
                const isImage = this.isFileImage(file);
                if (!isImage) return file;

                const validSize = this.validSizeInMb(file.size, max_size)
                const blobURL = URL.createObjectURL(file);
                //if the size is below 5mb no need to compress
                if (validSize){
                    return file;
                }

                const MAX_WIDTH = 1000;
                const MAX_HEIGHT = 1000;
                const MIME_TYPE = file.type;
                const QUALITY = 0.7;
                const img = new Image();
                img.src = blobURL;
                img.onerror = function () {
                    URL.revokeObjectURL(this.src);
                };

                return new Promise(resolve => {
                    img.onload = async function () {
                        URL.revokeObjectURL(self.src);
                        const canvas = document.createElement("canvas");
                        const [newWidth, newHeight] = self.calculateSize(img, MAX_WIDTH, MAX_HEIGHT);
                        canvas.width = newWidth;
                        canvas.height = newHeight;
                        let ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, newWidth, newHeight);

                        // Convert the image to JPG format
                        canvas.toBlob(
                            (blob) => {
                                resolve(new File([blob], file.name.replace(/\.[^/.]+$/, ".jpg"), { type: MIME_TYPE_JPG }));
                            },
                            MIME_TYPE_JPG, // Use JPG MIME type
                            QUALITY
                        );
                    };
                })
            },

            getCanvasBlobToFile(canvas, MIME_TYPE = 'image/jpeg', QUALITY = 0.7) {
                return new Promise(function (resolve, reject) {
                    canvas.toBlob(
                        (blob) => {
                            resolve(new File([blob], "compress-image",{type: MIME_TYPE}));
                        },
                        MIME_TYPE,
                        QUALITY
                    );
                })
            },

            calculateSize(img, maxWidth, maxHeight) {
                let width = img.width;
                let height = img.height;

                // calculate the width and height, constraining the proportions
                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round((height * maxWidth) / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round((width * maxHeight) / height);
                        height = maxHeight;
                    }
                }
                return [width, height];
            },

            // Utility functions for demo purpose
            displayInfo(label, file) {
                const p = document.createElement('p');
                p.innerText = `${label} - ${this.readableBytes(file.size)}`;
                document.getElementById('show').append(p);
            },

            readableBytes(bytes) {
                const i = Math.floor(Math.log(bytes) / Math.log(1024));
                const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
            },
        }
        Vue.prototype.$image = image;
    }}


